<template>
  <div class="vx-card mt-5 mb-5" style="margin-bottom: 15px;">
    <div class="flex flex-wrap" style="font-size: 40px; justify-content: center; margin-bottom: 33px;">
      <label style="margin-top: 12px !important;"
        >NİTRO MALİ TABLO
        <feather-icon icon="RefreshCwIcon" title="Yenile" svgClasses="h-5 mr-5 hover:text-danger cursor-pointer" @click="GetCases()" />
      </label>
    </div>
    <template v-if="$store.state.userData.authorizationList.find((f) => f.authorizationId == '9') != null">
      <reconcile v-if="reconcilePopupParent" :reconcilePopupProp="reconcilePopupParent" :customerIdProp="customerIdProp" @ReconcilePopupClosedChildEmit="ReconcilePopupClosedParentEmitCatch($event)"></reconcile>

      <div class="vx-row ml-5 mr-5" style="margin-top: 30px; margin-bottom: 99px;">
        <div class="vx-col md:w-1/3 w-full">
          <div style="margin: 5px; text-align: center; font-size: 20px;">
            <label><b>NİTRO KREDİ KARTI</b></label>
          </div>
          <div style="margin: 5px; text-align: center; font-size: 15px;">
            <b> {{ getSumOfList(nitroCreditCardList) }} {{ " TL" }}</b>
          </div>
          <div>
            <div style="cursor: pointer; width: 100px; margin-bottom: -35px; margin-top: 20px;" class="px-4 py-1 flex items-center">
              <feather-icon svgClasses="w-6 h-6" icon="DownloadIcon" class="mr-2" />
              <JsonExcel :data="nitroCreditCardList" class><b>İndir</b></JsonExcel>
            </div>
            <vs-table search noDataText="Data yok" :maxItems="10" :pagination="true" :data="nitroCreditCardList">
              <template slot="thead">
                <vs-th class="w-1/3">Adı</vs-th>
                <vs-th class="w-1/6">Tutar</vs-th>
                <vs-th class="w-1/6">İşlemler</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="tr.accountId" v-for="(tr, i) in data" class="pt-0 pb-1">
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <b> {{ i + 1 + " . " }}</b> {{ tr.accountDescription + " - " + tr.currencyName }}
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    {{ tr.amount + " " + tr.currencyName }}
                  </vs-td>

                  <td class="flex">
                    <a :href="'/AccountCompanyConsolidatedMovementWatch/' + tr.accountCompanyTypeId + '/' + tr.currencyId" style="margin-left: 15px; margin-top: 5px; color:  #7393B3 ;" target="_blank"><b>Hesap</b></a>
                  </td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>

        <div class="vx-col md:w-1/3 w-full">
          <div style="margin: 5px; text-align: center; font-size: 20px; ">
            <label><b>NİTRO BANKA HESAPLARI</b></label>
          </div>
          <div style="margin: 5px; text-align: center; font-size: 15px;">
            <b> {{ getSumOfList(nitroBankList) }}{{ " TL" }}</b>
          </div>
          <div>
            <div style="cursor: pointer; width: 100px; margin-bottom: -35px; margin-top: 20px;" class="px-4 py-1 flex items-center">
              <feather-icon svgClasses="w-6 h-6" icon="DownloadIcon" class="mr-2" />
              <JsonExcel :data="nitroBankList" class><b>İndir</b></JsonExcel>
            </div>
            <vs-table search noDataText="Banka yok" :maxItems="10" :pagination="true" :data="nitroBankList">
              <template slot="thead">
                <vs-th class="w-1/3">Kasa Adı</vs-th>
                <vs-th class="w-1/6">Tutar</vs-th>
                <vs-th class="w-1/6">İşlemler</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="tr.accountId" v-for="(tr, i) in data" class="pt-0 pb-1">
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <b> {{ i + 1 + " . " }}</b> {{ tr.accountDescription + " - " + tr.currencyName }}
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    {{ tr.amount + " " + tr.currencyName }}
                  </vs-td>

                  <td class="flex">
                    <a :href="'/AccountCompanyConsolidatedMovementWatch/' + tr.accountCompanyTypeId + '/' + tr.currencyId" style="margin-left: 15px; margin-top: 5px; color:  #7393B3 ;" target="_blank"><b>Hesap</b></a>
                  </td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>

        <div class="vx-col md:w-1/3 w-full">
          <div style="margin: 5px; text-align: center; font-size: 20px; ">
            <label><b>NİTRO NAKİT KASALARI</b></label>
            <div style="margin: 5px; text-align: center; font-size: 15px;">
              <b> {{ getSumOfList(nitroCashRegionList) }}{{ " TL" }}</b>
            </div>
          </div>
          <div>
            <div style="cursor: pointer; width: 100px; margin-bottom: -35px; margin-top: 20px;" class="px-4 py-1 flex items-center">
              <feather-icon svgClasses="w-6 h-6" icon="DownloadIcon" class="mr-2" />
              <JsonExcel :data="nitroCashRegionList" class><b>İndir</b></JsonExcel>
            </div>
            <vs-table search noDataText="Nakit hesabı yok" :maxItems="10" :pagination="true" :data="nitroCashRegionList">
              <template slot="thead">
                <vs-th class="w-1/3">Kasa Adı</vs-th>
                <vs-th class="w-1/6">Tutar</vs-th>
                <vs-th class="w-1/6">İşlemler</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="tr.accountId" v-for="(tr, i) in data" class="pt-0 pb-1">
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <b> {{ i + 1 + " . " }}</b> {{ tr.accountDescription + " - " + tr.currencyName }}
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    {{ tr.amount + " " + tr.currencyName }}
                  </vs-td>

                  <td class="flex">
                    <a
                      :href="'/AccountCompanyConsolidatedCashRegionWatch/' + (tr.accountCompanyCashRegionId == null ? '-1' : tr.accountCompanyCashRegionId) + '/' + tr.currencyId"
                      style="margin-left: 15px; margin-top: 5px; color:  #7393B3 ;"
                      target="_blank"
                      ><b>Hesap</b></a
                    >
                  </td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </div>

      <div class="vx-row ml-5 mr-5" style="margin-top: 30px; margin-bottom: 99px;">
        <div class="vx-col md:w-1/3 w-full">
          <div style="margin: 5px; text-align: center; font-size: 20px; color: red;">
            <label><b>NİTRO BANKA KREDİLERİ</b></label>
          </div>
          <div style="margin: 5px; text-align: center; font-size: 15px;">
            <b> {{ getSumOfList(nitroBankCreditList) }} {{ " TL" }}</b>
          </div>
          <div>
            <div style="cursor: pointer; width: 100px; margin-bottom: -35px; margin-top: 20px;" class="px-4 py-1 flex items-center">
              <feather-icon svgClasses="w-6 h-6" icon="DownloadIcon" class="mr-2" />
              <JsonExcel :data="nitroBankCreditList" class><b>İndir</b></JsonExcel>
            </div>
            <vs-table search noDataText="Gider yok" :maxItems="10" :pagination="true" :data="nitroBankCreditList">
              <template slot="thead">
                <vs-th class="w-1/3">Adı</vs-th>
                <vs-th class="w-1/6">Tutar</vs-th>
                <vs-th class="w-1/6">İşlemler</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="tr.accountId" v-for="(tr, i) in data" class="pt-0 pb-1">
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <b> {{ i + 1 + " . " }}</b> {{ tr.accountDescription + " - " + tr.currencyName }}
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    {{ tr.amount + " " + tr.currencyName }}
                  </vs-td>

                  <td class="flex">
                    <a :href="'/AccountCompanyConsolidatedMovementWatch/' + tr.accountCompanyTypeId + '/' + tr.currencyId" style="margin-left: 15px; margin-top: 5px; color:  #7393B3 ;" target="_blank"><b>Hesap</b></a>
                  </td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>

        <!--  NİTRO TORBA HESAP -->
        <div class="vx-col md:w-1/3 w-full">
          <div style="margin: 5px; text-align: center; font-size: 20px;">
            <label><b>NİTRO TORBA HESAP</b></label>
            <div style="margin: 5px; text-align: center; font-size: 15px;">
              <b> {{ getSumOfList(nitroMixedAccount) }} {{ " TL" }}</b>
            </div>
          </div>
          <div>
            <div style="cursor: pointer; width: 100px; margin-bottom: -35px; margin-top: 20px;" class="px-4 py-1 flex items-center">
              <feather-icon svgClasses="w-6 h-6" icon="DownloadIcon" class="mr-2" />
              <JsonExcel :data="nitroMixedAccount" class><b>İndir</b></JsonExcel>
            </div>
            <vs-table search noDataText="Nakit hesabı yok" :maxItems="10" :pagination="true" :data="nitroMixedAccount">
              <template slot="thead">
                <vs-th class="w-1/3">Kasa Adı</vs-th>
                <vs-th class="w-1/6">Tutar</vs-th>
                <vs-th class="w-1/6">İşlemler</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="tr.accountId" v-for="(tr, i) in data" class="pt-0 pb-1">
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <b> {{ i + 1 + " . " }}</b> {{ tr.accountDescription + " - " + tr.currencyName }}
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    {{ tr.amount + " " + tr.currencyName }}
                  </vs-td>

                  <td class="flex">
                    <a :href="'/AccountCompanyConsolidatedMovementWatch/' + tr.accountCompanyTypeId + '/' + tr.currencyId" style="margin-left: 15px; margin-top: 5px; color:  #7393B3 ;" target="_blank"><b>Hesap</b></a>
                  </td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </div>

      <div class="vx-row ml-5 mr-5" style="margin-top: 30px; margin-bottom: 99px;">
        <div class="vx-col md:w-1/2 w-full">
          <div style="margin: 5px; text-align: center; font-size: 20px;">
            <label><b>BORÇLU MÜŞTERİLER</b></label>
          </div>
          <div style="margin: 5px; text-align: center; font-size: 15px;">
            <b> {{ getSumOfList(owedCustomerList) }}{{ " TL" }}</b>
          </div>
          <div>
            <div style="cursor: pointer; width: 100px; margin-bottom: -35px; margin-top: 20px;" class="px-4 py-1 flex items-center">
              <feather-icon svgClasses="w-6 h-6" icon="DownloadIcon" class="mr-2" />
              <JsonExcel :data="owedCustomerList" class><b>İndir</b></JsonExcel>
            </div>
            <vs-table search noDataText="Müşteri yok" :maxItems="10" :pagination="true" :data="owedCustomerList">
              <template slot="thead">
                <vs-th class="w-1/3">Kasa Adı</vs-th>
                <vs-th class="w-1/6">Tutar</vs-th>
                <vs-th class="w-1/6">İşlemler</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="tr.accountId" v-for="(tr, i) in data" class="pt-0 pb-1">
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <b> {{ i + 1 + " . " }}</b> {{ tr.accountDescription.substr(0, 30) + " - " + tr.currencyName }}
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    {{ tr.amount + " " + tr.currencyName }}
                  </vs-td>

                  <td class="flex" style="margin-left:-22px">
                    <a
                      href="#"
                      class="danger"
                      @click.stop="
                        reconcilePopupParent = true;
                        customerIdProp = tr.customerId;
                      "
                      style="margin-left: 15px; margin-top: 5px;"
                      ><b>Reconcile</b></a
                    >

                    <a :href="'/contactsView/' + tr.customerId" style="margin-left: 15px; margin-top: 5px; color: orange;" target="_blank"><b>Müşteri</b></a>
                    <a :href="'/AccountMovementWatch/' + tr.accountId" style="margin-left: 15px; margin-top: 5px; color:  #7393B3 ;" target="_blank"><b>Hesap</b></a>
                    <a :href="'/SaleByCustomerId/' + tr.customerId" style="margin-left: 15px; margin-top: 5px; color: red;" target="_blank"><b>Satış</b></a>
                    <a :href="'/MoneyTransferByCustomerId/' + tr.customerId" style="margin-left: 15px; margin-top: 5px; color: darkgray;" target="_blank"><b>Transfer</b></a>
                    <a :href="'/IncomeByCustomerId/' + tr.customerId" style="margin-left: 15px; margin-top: 5px; color: darkred;" target="_blank"><b>Ödeme</b></a>
                  </td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
        <div class="vx-col md:w-1/2 w-full">
          <div style="margin: 5px; text-align: center; font-size: 20px; color: red;">
            <label><b>ALACAKLI MÜŞTERİLER</b></label>
          </div>
          <div style="margin: 5px; text-align: center; font-size: 15px;">
            <b> {{ getSumOfList(owedToCustomerList) }} {{ " TL" }}</b>
          </div>
          <div>
            <div style="cursor: pointer; width: 100px; margin-bottom: -35px; margin-top: 20px;" class="px-4 py-1 flex items-center">
              <feather-icon svgClasses="w-6 h-6" icon="DownloadIcon" class="mr-2" />
              <JsonExcel :data="owedToCustomerList" class><b>İndir</b></JsonExcel>
            </div>
            <vs-table search noDataText="Müşteri yok" :maxItems="10" :pagination="true" :data="owedToCustomerList">
              <template slot="thead">
                <vs-th class="w-1/3">Kasa Adı</vs-th>
                <vs-th class="w-1/6">Tutar</vs-th>
                <vs-th class="w-1/6">İşlemler</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="tr.accountId" v-for="(tr, i) in data" class="pt-0 pb-1">
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <b> {{ i + 1 + " . " }}</b> {{ tr.accountDescription.substr(0, 30) + " - " + tr.currencyName }}
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    {{ tr.amount + " " + tr.currencyName }}
                  </vs-td>

                  <td class="flex" style="margin-left:-22px">
                    <a
                      href="#"
                      class="danger"
                      @click.stop="
                        reconcilePopupParent = true;
                        customerIdProp = tr.customerId;
                      "
                      style="margin-left: 15px; margin-top: 5px;"
                      ><b>Reconcile</b></a
                    >
                    <a :href="'/contactsView/' + tr.customerId" style="margin-left: 15px; margin-top: 5px; color: orange;" target="_blank"><b>Müşteri</b></a>
                    <a :href="'/AccountMovementWatch/' + tr.accountId" style="margin-left: 15px; margin-top: 5px; color:  #7393B3 ;" target="_blank"><b>Hesap</b></a>
                    <a :href="'/SaleByCustomerId/' + tr.customerId" style="margin-left: 15px; margin-top: 5px; color: red;" target="_blank"><b>Satış</b></a>
                    <a :href="'/MoneyTransferByCustomerId/' + tr.customerId" style="margin-left: 15px; margin-top: 5px; color: darkgray;" target="_blank"><b>Transfer</b></a>
                    <a :href="'/IncomeByCustomerId/' + tr.customerId" style="margin-left: 15px; margin-top: 5px; color: darkred;" target="_blank"><b>Ödeme</b></a>
                  </td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
        <div v-if="1 == 2" class="vx-col md:w-1/3 w-full">
          <div style="margin: 5px; text-align: center; font-size: 20px; color: red;">
            <label><b>NİTRO BÖLGE BAZLI SATIŞ</b></label>
          </div>
          <div style="margin: 5px; text-align: center; font-size: 15px;">
            <b> {{ getSumOfList(nitroSaleRegionList) }} {{ " TL" }}</b>
          </div>
          <div>
            <div style="cursor: pointer; width: 100px; margin-bottom: -35px; margin-top: 20px;" class="px-4 py-1 flex items-center">
              <feather-icon svgClasses="w-6 h-6" icon="DownloadIcon" class="mr-2" />
              <JsonExcel :data="nitroSaleRegionList" class><b>İndir</b></JsonExcel>
            </div>
            <vs-table search noDataText="Bölge yok" :maxItems="10" :pagination="true" :data="nitroSaleRegionList">
              <template slot="thead">
                <vs-th class="w-1/3">Kasa Adı</vs-th>
                <vs-th class="w-1/6">Tutar</vs-th>
                <vs-th class="w-1/6">İşlemler</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="tr.accountId" v-for="(tr, i) in data" class="pt-0 pb-1">
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <b> {{ i + 1 + " . " }}</b> {{ tr.accountDescription + " - " + tr.currencyName }}
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    {{ tr.amount + " " + tr.currencyName }}
                  </vs-td>

                  <td class="flex">
                    <a :href="'/AccountMovementWatch/' + tr.accountId" style="margin-left: 15px; margin-top: 5px; color:  #7393B3 ;" target="_blank"><b>Hesap</b></a>
                  </td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </div>

      <!--TEDARİKÇİLER -->
      <!--TEDARİKÇİLER -->
      <div class="vx-row ml-5 mr-5" style="margin-top: 30px; margin-bottom: 99px;">
        <div class="vx-col md:w-1/2 w-full">
          <div style="margin: 5px; text-align: center; font-size: 20px;">
            <label><b>BORÇLU TEDARİKÇİLER</b></label>
          </div>
          <div style="margin: 5px; text-align: center; font-size: 15px;">
            <b> {{ getSumOfList(owedSupplierList) }}{{ " TL" }}</b>
          </div>
          <div>
            <div style="cursor: pointer; width: 100px; margin-bottom: -35px; margin-top: 20px;" class="px-4 py-1 flex items-center">
              <feather-icon svgClasses="w-6 h-6" icon="DownloadIcon" class="mr-2" />
              <JsonExcel :data="owedSupplierList" class><b>İndir</b></JsonExcel>
            </div>
            <vs-table search noDataText="Müşteri yok" :maxItems="10" :pagination="true" :data="owedSupplierList">
              <template slot="thead">
                <vs-th class="w-1/3">Kasa Adı</vs-th>
                <vs-th class="w-1/6">Tutar</vs-th>
                <vs-th class="w-1/6">İşlemler</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="tr.accountId" v-for="(tr, i) in data" class="pt-0 pb-1">
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <b> {{ i + 1 + " . " }}</b> {{ tr.accountDescription.substr(0, 30) + " - " + tr.currencyName }}
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    {{ tr.amount + " " + tr.currencyName }}
                  </vs-td>

                  <td class="flex" style="margin-left:-22px">
                    <a
                      href="#"
                      class="danger"
                      @click.stop="
                        reconcilePopupParent = true;
                        customerIdProp = tr.customerId;
                      "
                      style="margin-left: 15px; margin-top: 5px;"
                      ><b>Reconcile</b></a
                    >

                    <a :href="'/contactsView/' + tr.customerId" style="margin-left: 15px; margin-top: 5px; color: orange;" target="_blank"><b>Müşteri</b></a>
                    <a :href="'/AccountMovementWatch/' + tr.accountId" style="margin-left: 15px; margin-top: 5px; color:  #7393B3 ;" target="_blank"><b>Hesap</b></a>
                    <a :href="'/SaleByCustomerId/' + tr.customerId" style="margin-left: 15px; margin-top: 5px; color: red;" target="_blank"><b>Satış</b></a>
                    <a :href="'/MoneyTransferByCustomerId/' + tr.customerId" style="margin-left: 15px; margin-top: 5px; color: darkgray;" target="_blank"><b>Transfer</b></a>
                    <a :href="'/IncomeByCustomerId/' + tr.customerId" style="margin-left: 15px; margin-top: 5px; color: darkred;" target="_blank"><b>Ödeme</b></a>
                  </td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>

        <!-- ALACAKLI TEDARİKÇİLER -->
        <div class="vx-col md:w-1/2 w-full">
          <div style="margin: 5px; text-align: center; font-size: 20px; color: red;">
            <label><b>ALACAKLI TEDARİKÇİLER</b></label>
          </div>
          <div style="margin: 5px; text-align: center; font-size: 15px;">
            <b> {{ getSumOfList(owedToCustomerSupplierList) }} {{ " TL" }}</b>
          </div>
          <div>
            <div style="cursor: pointer; width: 100px; margin-bottom: -35px; margin-top: 20px;" class="px-4 py-1 flex items-center">
              <feather-icon svgClasses="w-6 h-6" icon="DownloadIcon" class="mr-2" />
              <JsonExcel :data="owedToCustomerSupplierList" class><b>İndir</b></JsonExcel>
            </div>
            <vs-table search noDataText="Müşteri yok" :maxItems="10" :pagination="true" :data="owedToCustomerSupplierList">
              <template slot="thead">
                <vs-th class="w-1/3">Kasa Adı</vs-th>
                <vs-th class="w-1/6">Tutar</vs-th>
                <vs-th class="w-1/6">İşlemler</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="tr.accountId" v-for="(tr, i) in data" class="pt-0 pb-1">
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <b> {{ i + 1 + " . " }}</b> {{ tr.accountDescription.substr(0, 30) + " - " + tr.currencyName }}
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    {{ tr.amount + " " + tr.currencyName }}
                  </vs-td>

                  <td class="flex" style="margin-left:-22px">
                    <a
                      href="#"
                      class="danger"
                      @click.stop="
                        reconcilePopupParent = true;
                        customerIdProp = tr.customerId;
                      "
                      style="margin-left: 15px; margin-top: 5px;"
                      ><b>Reconcile</b></a
                    >
                    <a :href="'/contactsView/' + tr.customerId" style="margin-left: 15px; margin-top: 5px; color: orange;" target="_blank"><b>Müşteri</b></a>
                    <a :href="'/AccountMovementWatch/' + tr.accountId" style="margin-left: 15px; margin-top: 5px; color:  #7393B3 ;" target="_blank"><b>Hesap</b></a>
                    <a :href="'/SaleByCustomerId/' + tr.customerId" style="margin-left: 15px; margin-top: 5px; color: red;" target="_blank"><b>Satış</b></a>
                    <a :href="'/MoneyTransferByCustomerId/' + tr.customerId" style="margin-left: 15px; margin-top: 5px; color: darkgray;" target="_blank"><b>Transfer</b></a>
                    <a :href="'/IncomeByCustomerId/' + tr.customerId" style="margin-left: 15px; margin-top: 5px; color: darkred;" target="_blank"><b>Ödeme</b></a>
                  </td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </div>

      <div class="vx-row ml-5 mr-5" style="margin-top: 30px; margin-bottom: 99px;">
        <!-- NİTRO EN ÇOK SATIŞ YAPAN (TL CONSOLIDATE) -->
        <div v-if="1 == 2" class="vx-col md:w-1/4 w-full">
          <div style="margin: 5px; text-align: center; font-size: 20px; color: red;">
            <label><b>NİTRO EN ÇOK SATIŞ YAPAN (TL CONSOLIDATE)</b></label>
          </div>
          <div>
            <div style="cursor: pointer; width: 100px; margin-bottom: -35px; margin-top: 20px;" class="px-4 py-1 flex items-center">
              <feather-icon svgClasses="w-6 h-6" icon="DownloadIcon" class="mr-2" />
              <JsonExcel :data="nitroMostSalePersonnelList" class><b>İndir</b></JsonExcel>
            </div>
            <vs-table search noDataText="Personel yok" :maxItems="10" :pagination="true" :data="nitroMostSalePersonnelList">
              <template slot="thead">
                <vs-th class="w-1/3">Kasa Adı</vs-th>
                <vs-th class="w-1/6">Tutar</vs-th>
                <vs-th class="w-1/6">İşlemler</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="tr.accountId" v-for="(tr, i) in data" class="pt-0 pb-1">
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <b> {{ i + 1 + " . " }}</b> {{ tr.accountDescription }}
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    {{ tr.amount }}
                  </vs-td>

                  <td class="flex">
                    <a :href="'/ConsolidatedPersonnelWatch/' + tr.userId + '/' + 'Sale'" style="margin-left: 15px; margin-top: 5px; color:  #7393B3 ;" target="_blank"><b>Hesap</b></a>
                  </td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>

        <!-- NİTRO KİŞİ BAZLI NAKİT -->
        <div v-if="1 == 2" class="vx-col md:w-1/4 w-full">
          <div class="vx-col md:w-1/3 w-full">
            <div style="margin: 5px; text-align: center; font-size: 20px; color: red;">
              <label><b>NİTRO HARCAMA GİDERLERİ</b></label>
            </div>
            <div style="margin: 5px; text-align: center; font-size: 15px;">
              <b> {{ getSumOfList(owedToCustomerList) }} {{ " TL" }}</b>
            </div>
            <div>
              <div style="cursor: pointer; width: 100px; margin-bottom: -35px; margin-top: 20px;" class="px-4 py-1 flex items-center">
                <feather-icon svgClasses="w-6 h-6" icon="DownloadIcon" class="mr-2" />
                <JsonExcel :data="nitroExpenseList" class><b>İndir</b></JsonExcel>
              </div>
              <vs-table search noDataText="Gider yok" :maxItems="10" :pagination="true" :data="nitroExpenseList">
                <template slot="thead">
                  <vs-th class="w-1/3">Kasa Adı</vs-th>
                  <vs-th class="w-1/6">Tutar</vs-th>
                  <vs-th class="w-1/6">İşlemler</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr :key="tr.accountId" v-for="(tr, i) in data" class="pt-0 pb-1">
                    <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                      <b> {{ i + 1 + " . " }}</b> {{ tr.accountDescription + " - " + tr.currencyName }}
                    </vs-td>
                    <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                      {{ tr.amount + " " + tr.currencyName }}
                    </vs-td>

                    <td class="flex">
                      <a :href="'/AccountCompanyConsolidatedMovementWatch/' + tr.accountCompanyTypeId + '/' + tr.currencyId" style="margin-left: 15px; margin-top: 5px; color:  #7393B3 ;" target="_blank"><b>Hesap</b></a>
                    </td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>

          <div style="margin: 5px; text-align: center; font-size: 20px; color: red;">
            <label><b>NİTRO KİŞİ BAZLI NAKİT</b></label>
          </div>
          <div>
            <div style="cursor: pointer; width: 100px; margin-bottom: -35px; margin-top: 20px;" class="px-4 py-1 flex items-center">
              <feather-icon svgClasses="w-6 h-6" icon="DownloadIcon" class="mr-2" />
              <JsonExcel :data="nitroCashList" class><b>İndir</b></JsonExcel>
            </div>
            <vs-table search noDataText="Nakit hesabı yok" :maxItems="10" :pagination="true" :data="nitroCashList">
              <template slot="thead">
                <vs-th class="w-1/3">Kasa Adı</vs-th>
                <vs-th class="w-1/6">Tutar</vs-th>
                <vs-th class="w-1/6">İşlemler</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="tr.accountId" v-for="(tr, i) in data" class="pt-0 pb-1">
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <b> {{ i + 1 + " . " }}</b> {{ tr.accountDescription + " - " + tr.currencyName }}
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    {{ tr.amount + " " + tr.currencyName }}
                  </vs-td>

                  <td class="flex">
                    <a :href="'/AccountCompanyMovementWatch/' + tr.accountId" style="margin-left: 15px; margin-top: 5px; color:  #7393B3 ;" target="_blank"><b>Hesap</b></a>
                  </td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </div>

      <div class="vx-row ml-5 mr-5" style="margin-top: 30px; margin-bottom: 99px;"></div>
    </template>
  </div>
</template>

<script>
import { repository } from "@/_services/repository.js";
import JsonExcel from "vue-json-excel";
import Reconcile from "../Account/Reconcile";

export default {
  components: {
    JsonExcel,
    Reconcile,
  },
  data() {
    return {
      reconcilePopupParent: false,
      customerIdProp: null,
      nitroSaleCaseList: [],
      nitroBankList: [],
      nitroCashRegionList: [],
      nitroCashList: [],
      nitroMixedAccount: [],
      nitroRegionCashList: [],
      owedCustomerList: [],
      owedSupplierList: [],
      owedToCustomerList: [],
      owedToCustomerSupplierList: [],
      nitroExpenseList: [],
      nitroMostSalePersonnelList: [],
      nitroSaleRegionList: [],

      nitroCreditCardList: [],
      nitroBankCreditList: [],
    };
  },

  created() {
    this.GetCases();
  },
  methods: {
    getSumOfList: function(list) {
      let sumTL = 0.0;

      list.forEach((element) => {
        sumTL += element.amountTL;
      });

      return sumTL.toFixed(2);
    },

    ReconcilePopupClosedParentEmitCatch: async function(v) {
      this.reconcilePopupParent = false;
      console.log("reconcile child is closed", v);
      this.$vs.loading();
      await this.GetOwedCustomer();
      await this.GetOwedToCustomer();
      this.$vs.loading.close();
    },

    GetNitroSaleCase: async function() {
      this.nitroSaleCaseList = await repository.postEntity("Accounting/GetNitroSaleCase", {}).then((r) => r.list);
    },

    GetNitroMixedAaccount: async function() {
      this.nitroMixedAccount = await repository.postEntity("Accounting/GetNitroMixedAaccount", {}).then((r) => r.list);
    },

    GetNitroPaymentCase: async function() {
      this.nitroBankList = await repository.postEntity("Accounting/GetNitroBank", {}).then((r) => r.list);
    },

    GetOwedCustomer: async function() {
      this.owedCustomerList = await repository.postEntity("Accounting/GetOwedCustomer", {}).then((r) => r.list);
    },

    GetOwedSupplier: async function() {
      this.owedSupplierList = await repository.postEntity("Accounting/GetOwedSupplier", {}).then((r) => r.list);
    },

    GetOwedToCustomer: async function() {
      let owedToList = await repository.postEntity("Accounting/GetOwedToCustomer", {}).then((r) => r.list);

      this.owedToCustomerList = owedToList.filter((r) => r.isSupplier == 0);
      this.owedToCustomerSupplierList = owedToList.filter((r) => r.isSupplier == 1);
    },

    GetNitroExpense: async function() {
      this.nitroExpenseList = await repository.postEntity("Accounting/GetNitroExpense", {}).then((r) => r.list);
    },

    GetNitroMostSalePersonnel: async function() {
      this.nitroMostSalePersonnelList = await repository.postEntity("Accounting/GetNitroMostSalePersonnel", {}).then((r) => r.list);
    },

    GetNitroSaleRegion: async function() {
      this.nitroSaleRegionList = await repository.postEntity("Accounting/GetNitroSaleRegion", {}).then((r) => r.list);
    },

    GetNitroCash: async function() {
      this.nitroCashList = await repository.postEntity("Accounting/GetNitroCash", {}).then((r) => r.list);
    },
    GetNitroCashRegion: async function() {
      this.nitroCashRegionList = await repository.postEntity("Accounting/GetNitroCashRegion", {}).then((r) => r.list);
    },

    GetNitroCreditCard: async function() {
      this.nitroCreditCardList = await repository.postEntity("Accounting/GetNitroCreditCard", {}).then((r) => r.list);
    },

    GetNitroBankCredit: async function() {
      this.nitroBankCreditList = await repository.postEntity("Accounting/GetNitroBankCredit", {}).then((r) => r.list);
    },

    GetCases: async function() {
      this.$vs.loading();
      await Promise.all([
        this.GetNitroSaleCase(),
        this.GetNitroPaymentCase(),
        this.GetOwedCustomer(),
        this.GetOwedToCustomer(),
        // this.GetNitroExpense(),
        // this.GetNitroMostSalePersonnel(),
        // this.GetNitroSaleRegion(),
        // this.GetNitroCash(),
        this.GetNitroCashRegion(),
        this.GetNitroMixedAaccount(),
        this.GetNitroCreditCard(),
        this.GetNitroBankCredit(),
        this.GetOwedSupplier(),
      ]);
      this.$vs.loading.close();
    },
  },
};
</script>
